import { WidgetTypes } from 'types'

export const FEATURE_NAME = 'init'

export interface IState {
  widgetType: WidgetTypes | null
}
